import { memo } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";

const METRIC_LABELS = {
	satisfaction: "Rata-rata Kepuasan",
	ease: "Rata-rata Kemudahan",
	performance: "Rata-rata Performa",
	stability: "Rata-rata Stabilitas",
};

const CARD_STYLES = [
	{ accent: "#f8fbff", border: "#dbeafe", label: "Total Responden", key: "total" },
	{ accent: "#eef8ff", border: "#bfdbfe", metricKey: "satisfaction" },
	{ accent: "#f1fdf5", border: "#bbf7d0", metricKey: "ease" },
	{ accent: "#fff8ef", border: "#fde68a", metricKey: "performance" },
	{ accent: "#fff5f5", border: "#fecaca", metricKey: "stability" },
];

const formatAverage = (value) => {
	if (value == null || Number.isNaN(value)) return "-";
	return `${Number(value).toFixed(1)} / 5`;
};

const SurveyStatsCards = ({ analytics }) => {
	if (!analytics) return null;

	const cards = CARD_STYLES.map((style) => {
		if (style.key === "total") {
			return {
				...style,
				value: analytics.totalRespondents ?? 0,
			};
		}

		return {
			...style,
			label: METRIC_LABELS[style.metricKey] ?? style.metricKey,
			value: formatAverage(analytics.averages?.[style.metricKey]),
		};
	});

	return (
		<div className="mb-4">
			<div className="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-2 mb-3">
				<div>
					<h6 className="mb-1 fw-semibold">Ringkasan Survey Aplikasi</h6>
					<small className="text-muted">
						Agregat jawaban responden yang telah menyelesaikan seluruh pertanyaan.
					</small>
				</div>
				<div className="rounded-pill border px-3 py-2 small text-muted bg-white">
					{analytics.totalRespondents ?? 0} responden
				</div>
			</div>

			<Row className="g-3">
				{cards.map((card) => (
					<Col xs="6" md="4" lg key={card.label}>
						<Card
							className="h-100 border-0 rounded-4"
							style={{
								border: `1px solid ${card.border}`,
								boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
							}}
						>
							<CardBody
								className="p-3"
								style={{
									background: `linear-gradient(135deg, ${card.accent} 0%, #ffffff 100%)`,
								}}
							>
								<div className="d-flex justify-content-between align-items-center">
									<div>
										<div className="h4 mb-1 fw-bold text-dark">{card.value}</div>
										<small className="text-muted d-block">{card.label}</small>
									</div>
									<span
										className="rounded-circle"
										style={{
											width: 10,
											height: 10,
											background: card.border,
											flexShrink: 0,
										}}
									/>
								</div>
							</CardBody>
						</Card>
					</Col>
				))}
			</Row>
		</div>
	);
};

export default memo(SurveyStatsCards);
